import { createContext } from 'react';

export const SliderContext = createContext({});
